<template>
  <el-dialog
    title="宠物信息"
    :visible.sync="visible"
    :before-close="addPetStateClose"
    width="700px"
    :close-on-click-modal="false"
    id="addPetView"
  >
    <div class="titleView">
      <div>必填项:</div>
    </div>
    <el-form ref="form" :model="form" label-width="70px">
      <div class="formView">
        <div style="width: 58px; text-align: right; padding: 0 12px 0 0">
          宠物头像
        </div>
        <img
          style="width: 80px; height: 80px"
          src="../assets/img/uploadImg.png"
          @click="handleUploadClick"
          v-if="form.imageUrl == ''"
        />
        <input
          type="file"
          ref="file"
          style="width: 0; height: 0"
          @change="changeFile"
        />
        <el-image
          style="width: 80px; height: 80px"
          :src="form.imageUrl"
          v-if="form.imageUrl != ''"
          @click="handleUploadClick"
        ></el-image>
      </div>
      <el-form-item label="宠物昵称" class="petName">
        <el-input
          v-model="form.name"
          style="width: 200px"
          placeholder="请输入昵称"
        ></el-input>
      </el-form-item>
      <div class="formView">
        <el-form-item label="种类">
          <el-radio-group v-model="form.species" @change="handleSpeciesClick">
            <el-radio label="1">猫</el-radio>
            <el-radio label="2">犬</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="form.sex">
            <el-radio label="公">公</el-radio>
            <el-radio label="母">母</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="formView">
        <el-form-item label="品种">
          <el-select
            v-model="form.breed"
            placeholder="请选择品种"
            style="width: 150px"
            @change="handleBreedClick"
          >
            <el-option
              v-for="item in breeds"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="颜色" v-if="form.breed != ''">
          <el-select
            v-model="form.color"
            placeholder="请选择颜色"
            style="width: 120px"
            @change="handleColorClick"
          >
            <el-option
              v-for="item in colors"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="formView">
        <el-form-item label="出生日期">
          <el-date-picker
            v-model="form.birthValue"
            type="date"
            placeholder="选择日期"
            style="width: 150px"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="脖圈号">
          <el-input
            v-model="form.collarValue"
            placeholder="请输入脖圈号"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item label="星级" v-if="form.color != ''">
          <el-select
            v-model="form.level"
            placeholder="请选择品种"
            style="width: 150px"
          >
            <el-option
              v-for="item in levels"
              :key="item._id"
              :label="item.text"
              :value="item._id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="formView">
        <el-form-item label="毛发">
          <el-radio-group v-model="form.petHair">
            <el-radio label="1">短毛</el-radio>
            <el-radio label="2">长毛</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="类型">
          <el-radio-group v-model="form.petSpecial">
            <el-radio label="11" v-if="form.species == '2'">普通犬</el-radio>
            <el-radio label="12" v-if="form.species == '2'">特种犬</el-radio>
            <el-radio label="21" v-if="form.species == '1'">普通猫</el-radio>
            <el-radio label="22" v-if="form.species == '1'">特种猫</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>

      <div class="titleView">
        <div>选填项:</div>
      </div>
      <div class="formView">
        <el-form-item label="绝育">
          <el-radio-group v-model="form.sterilization">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="免疫">
          <el-radio-group v-model="form.immunity">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="formView">
        <el-form-item label="芯片编号">
          <el-input
            v-model="form.chip"
            placeholder="请输入芯片编号"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item label="体重">
          <el-input
            v-model="form.weight"
            placeholder="请输入体重(KG)"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item label="特征">
          <el-select
            v-model="form.custom_features"
            multiple
            placeholder="请选择特征"
            style="width: 120px"
          >
            <el-option
              v-for="item in featureData"
              :key="item._id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item label="备注">
        <el-input
          type="textarea"
          v-model="form.remark"
          resize="none"
          rows="3"
          style="width: 500px"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSubClick">确定</el-button>
        <el-button @click="handleCancelClick">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { breed, colors, levels, simpleadd } from "@/api/purchaseApi.js";
import { getPetType } from "@/api/program.js";
export default {
  props: {
    addPetState: {
      default: false,
    },
    petInfo: {
      default: null,
    },
    petType: {
      default: "1",
    },
  },
  data() {
    return {
      visible: true,
      form: {
        imageUrl: "", //上传图片地址
        name: "", //昵称
        species: "1", //种类
        sex: "公", //性别
        breed: "", //品种
        color: "", //颜色
        birthValue: "", //出生日期
        collarValue: "", //脖圈号
        level: "", //星级
        sterilization: "0", //绝育
        immunity: "0", //免疫
        chip: "", //芯片编号
        weight: 0, //体重
        remark: "", //备注
        petHair: "", //毛发
        petSpecial: "", //类型
        custom_features: [], //特征
      },
      breeds: [], //品种列表
      breedName: "", //品种名字
      colors: [], //颜色列表
      levels: [], //等级列表
      featureData: [], //特征
    };
  },
  mounted() {
    console.log();
    if (this.petType == "2") {
      console.log("宠物详情", this.petInfo);
      this.form.imageUrl = this.petInfo.cover == null ? "" : this.petInfo.cover;
      this.form.name = this.petInfo.inside_name;
      this.form.species = this.petInfo.apply_type.value;
      this.form.sex = this.petInfo.pet_sex;
      this.form.breed = this.petInfo.breed_info._id;
      this.form.color = this.petInfo.color;
      this.form.birthValue =
        this.petInfo.bron_date == null
          ? ""
          : Number(this.petInfo.bron_date) * 1000;
      this.form.collarValue = this.petInfo.inside_no;
      this.form.level = this.petInfo.pet_level.level_id;
      this.form.sterilization = this.petInfo.sterilization + "";
      this.form.immunity = this.petInfo.immunization + "";
      this.form.weight = this.petInfo.weight;
      this.form.remark = this.petInfo.remark;
      this.form.chip = this.petInfo.eprom_no;
      this.form.petSpecial = this.petInfo.pet_special.value;
      this.form.petHair = this.petInfo.pet_hair.value;
      this.form.custom_features = this.petInfo.custom_features;
      this.getColorData();
      this.getLevelData();
    }

    this.getPetType();
    this.getBreedData();
  },
  methods: {
    //取消
    handleCancelClick() {
      this.$emit("closeOn", false);
    },
    //提交确定
    handleSubClick() {
      console.log(this.form);
      let form = this.form;
      // console.log(form)
      if (form.imageUrl == "") {
        this.$message({
          message: "请选择头像",
          type: "error",
        });
        return;
      }
      if (form.name == "") {
        this.$message({
          message: "请输入昵称",
          type: "error",
        });
        return;
      }
      if (form.breed == "") {
        this.$message({
          message: "请选择品种",
          type: "error",
        });
        return;
      }
      if (form.color == "") {
        this.$message({
          message: "请选择颜色",
          type: "error",
        });
        return;
      }
      if (form.level == "") {
        this.$message({
          message: "请选择星级",
          type: "error",
        });
        return;
      }
      if (form.birthValue == "") {
        this.$message({
          message: "请选择出生日期",
          type: "error",
        });
        return;
      }
      if (form.petHair == "") {
        this.$message({
          message: "请选择毛发",
          type: "error",
        });
        return;
      }
      if (form.petSpecial == "") {
        this.$message({
          message: "请选择类型",
          type: "error",
        });
        return;
      }
      let bron_date = null;
      if (this.petType == "2") {
        bron_date = form.birthValue / 1000;
      } else {
        bron_date = form.birthValue.getTime() / 1000;
      }

      if (form.collarValue == "") {
        this.$message({
          message: "请输入脖圈号",
          type: "error",
        });
        return;
      }
      let params = {
        applyType: form.species, //种类
        sex: form.sex, //性别
        category_info: {
          _id: form.breed,
          name: this.breedName,
        }, //品种
        color: form.color, //颜色
        bron_date: bron_date, //出生日期
        inside_no: form.collarValue, //脖圈号
        inside_name: form.name, //昵称
        level_id: form.level, //星级
        cover: form.imageUrl, //头像
        sterilization: form.sterilization, //绝育
        immunization: form.immunity, //免疫
        weight: form.weight, //体重
        remark: form.remark, //备注
        eprom_no: form.chip, //芯片编号
        petHair: form.petHair, //毛发
        petSpecial: form.petSpecial, //类型
        custom_features: form.custom_features,
      };
      if (this.petType == "2") {
        params.petId = this.petInfo.petId;
      } else {
        params.petId = "";
      }
      console.log(params);
      simpleadd(params).then((res) => {
        if (res.code == 0) {
          console.log(res);
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.$emit("closeClick", false);
        }
      });
    },
    //转移触发上传按钮
    handleUploadClick() {
      this.$refs.file.click();
    },
    //上传
    changeFile(e) {
      var index = e.target.files[0].name.lastIndexOf(".");
      var ext = e.target.files[0].name.substr(index + 1);
      var formData = new FormData();
      if (ext === "png" || ext === "jpg" || ext === "jpeg") {
        formData.append("img", e.target.files[0]);
        this.$util.uploadImg_dir(formData, { dir: "petImg" }).then((data) => {
          console.log(data);
          if (data.timestamp) {
            this.form.imageUrl = data.url;
          }
        });
      } else {
        this.$message({
          message: "只能上传jpg,png格式的文件",
          type: "error",
        });
      }
    },
    //选择颜色
    handleColorClick() {
      this.getLevelData();
    },
    //获取星级
    getLevelData() {
      let params = {
        categoryId: this.form.breed,
        color: this.form.color,
      };
      levels(params).then((res) => {
        if (res.code == 0) {
          console.log("星级", res);
          this.levels = res.data;
        }
      });
    },
    //选择品种
    handleBreedClick() {
      this.form.color = "";
      this.form.level = "";
      let params = {
        categoryId: this.form.breed,
      };
      for (let i = 0; i < this.breeds.length; i++) {
        if (this.form.breed == this.breeds[i]._id) {
          this.breedName = this.breeds[i].name;
        }
      }
      colors(params).then((res) => {
        if (res.code == 0) {
          console.log(res);
          this.colors = res.data;
        }
      });
    },
    //获取品种
    getColorData() {
      let params = {
        categoryId: this.form.breed,
      };
      colors(params).then((res) => {
        if (res.code == 0) {
          console.log(res);
          this.colors = res.data;
        }
      });
    },
    //切换种类
    handleSpeciesClick() {
      this.getBreedData();
      this.form.breed = "";
      this.form.color = "";
    },
    //获取宠物品种
    getBreedData() {
      let params = {
        applyType: this.form.species,
      };
      breed(params).then((res) => {
        // console.log(res)
        if (res.code == 0) {
          this.breeds = res.data;
        }
      });
    },

    //向父组件发射关闭弹框
    addPetStateClose(done) {
      done();
      this.$emit("closeOn", false);
    },
    //特征列表
    getPetType() {
      getPetType({
        type: "宠物特征",
        calss: "服务字典",
      }).then((res) => {
        if (res.code == 0) {
          this.featureData = res.data.data;
        }
      });
    },
  },
  watch: {
    // 监视状态发生改变
    addPetState() {
      this.visible = this.addPetState;
    },
  },
};
</script>
<style lang="scss" scoped>
.titleView {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
}
.formView {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>
